module.exports = __webpack_public_path__ + "static/media/Gilroy-Thin-Italic.c7d79f75.ttf";